function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import withTheme from '../Theme/withTheme';
import { styledComponentsResponsiveStyles } from '../../utils/responsive';
import { getAspectRatio } from './utils';
var getDimensionStyles = function getDimensionStyles(_ref) {
  var hasLoaded = _ref.hasLoaded,
    fullWidth = _ref.fullWidth,
    loadingAspectRatio = _ref.loadingAspectRatio,
    height = _ref.height,
    width = _ref.width,
    loadingHeight = _ref.loadingHeight,
    loadingWidth = _ref.loadingWidth,
    maxHeight = _ref.maxHeight,
    maxWidth = _ref.maxWidth,
    transformation = _ref.transformation;
  var style = {
    height: height,
    width: width,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    paddingTop: null
  };
  if (hasLoaded) {
    if (fullWidth) {
      var aspectRatio = getAspectRatio(height, width);
      style.paddingTop = "".concat(aspectRatio * 100, "%");
      style.height = transformation === 'fit' ? 0 : 'auto';
      style.width = '100%';
    }
  } else if (loadingWidth || loadingHeight) {
    style.width = loadingWidth || width;
    style.height = loadingHeight || height;
  } else if (fullWidth) {
    style.paddingTop = "".concat(loadingAspectRatio * 100, "%");
    style.height = 0;
    style.width = '100%';
  }
  return "\n    height: ".concat(Number.isInteger(style.height) ? "".concat(style.height, "px") : style.height, ";\n    max-height: ").concat(Number.isInteger(style.maxHeight) ? "".concat(style.axHeight, "px") : style.maxHeight, ";\n    padding-top: ").concat(style.paddingTop, ";\n    width: ").concat(Number.isInteger(style.width) ? "".concat(style.width, "px") : style.width, ";\n    max-width: ").concat(Number.isInteger(style.maxWidth) ? "".concat(style.maxWidth, "px") : style.maxWidth, ";\n  ");
};
var ImageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  line-height: 0;\n  overflow: hidden;\n  text-align: center;\n  ", "\n  ", "\n"])), function (props) {
  var height = props.height,
    fullWidth = props.fullWidth,
    loadingAspectRatio = props.loadingAspectRatio,
    loadingHeight = props.loadingHeight,
    loadingWidth = props.loadingWidth,
    maxHeight = props.maxHeight,
    maxWidth = props.maxWidth,
    transformation = props.transformation,
    width = props.width,
    hasLoaded = props.hasLoaded;
  return getDimensionStyles({
    hasLoaded: hasLoaded,
    fullWidth: fullWidth,
    loadingAspectRatio: loadingAspectRatio,
    height: height,
    width: width,
    loadingHeight: loadingHeight,
    loadingWidth: loadingWidth,
    maxHeight: maxHeight,
    maxWidth: maxWidth,
    transformation: transformation
  });
}, function (props) {
  var responsive = props.responsive,
    uiTheme = props.uiTheme,
    hasLoaded = props.hasLoaded;
  return styledComponentsResponsiveStyles(uiTheme, responsive, function (breakpointProps) {
    return getDimensionStyles(_objectSpread({
      hasLoaded: hasLoaded
    }, Object.assign({}, props, breakpointProps)));
  });
});
ImageContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  fullWidth: PropTypes.bool,
  hasLoaded: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loadingAspectRatio: PropTypes.number,
  loadingHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loadingWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  responsive: PropTypes.array,
  style: PropTypes.object,
  transformation: PropTypes.string,
  uiTheme: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ImageContainer.defaultProps = {
  fullWidth: false,
  hasLoaded: false,
  height: null,
  loadingAspectRatio: null,
  loadingHeight: null,
  loadingWidth: null,
  maxHeight: null,
  maxWidth: null,
  responsive: null,
  style: {},
  transformation: null,
  uiTheme: null,
  width: null
};
ImageContainer.displayName = 'Image';
export default withTheme(ImageContainer);